import React from 'react'

const Background = ({ motion }) => {
    const icon = {
        hidden: {
          opacity: 0,
          pathLength: 0,
          fill: "rgba(255, 255, 255, 0)"
        },
        visible: {
          opacity: 1,
          pathLength: 1,
          fill: "rgba(255, 255, 255, 1)"
        }
      };
    return (
        <svg viewBox="0 0 599 515" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g opacity="0.4">
        <path opacity="0.4" d="M392.305 321.689C392.736 325.144 390.34 328.384 386.999 328.864C383.657 329.343 380.55 326.893 380.118 323.437C379.687 319.982 382.083 316.741 385.424 316.262C388.766 315.782 391.873 318.233 392.305 321.689Z" fill="#00B5AC"/>
        <path opacity="0.4" d="M364.164 30.8575C364.596 34.3129 362.2 37.5533 358.858 38.0328C355.517 38.5122 352.409 36.0615 351.978 32.6061C351.546 29.1508 353.942 25.9103 357.284 25.4309C360.625 24.9514 363.732 27.4022 364.164 30.8575Z" fill="#00B5AC"/>
        <path d="M529.117 428.288C529.548 431.743 527.152 434.983 523.811 435.463C520.469 435.942 517.362 433.492 516.93 430.036C516.499 426.581 518.895 423.341 522.236 422.861C525.578 422.382 528.685 424.832 529.117 428.288Z" fill="#00B5AC"/>
        <motion.path
        d="M-49.7754 123.814L107.522 238.896"
        variants={icon}
        initial="hidden"
        stroke="#00B5AC"
        animate="visible"
        transition={{
            default: { duration: 2, ease: "easeInOut" },
            fill: { duration: 2, ease: [1, 0, 0.8, 1] }
        }}
        />
        <motion.path
        d="M108.131 239.568L-44.9282 403.309"
        variants={icon}
        initial="hidden"
        stroke="#00B5AC"
        animate="visible"
        transition={{
            default: { duration: 2, ease: "easeInOut" },
            fill: { duration: 2, ease: [1, 0, 0.8, 1] }
        }}
        />
        <motion.path
        d="M-44.3198 404.133L167.727 458.281"
        variants={icon}
        initial="hidden"
        stroke="#00B5AC"
        animate="visible"
        transition={{
            default: { duration: 2, ease: "easeInOut" },
            fill: { duration: 2, ease: [1, 0, 0.8, 1] }
        }}
        />
        <motion.path
        d="M167.254 459.105L386.587 322.576"
        variants={icon}
        initial="hidden"
        stroke="#00B5AC"
        animate="visible"
        transition={{
            default: { duration: 2, ease: "easeInOut" },
            fill: { duration: 2, ease: [1, 0, 0.8, 1] }
        }}
        />
        <motion.path
        d="M386.114 323.162L523.023 428.577"
        variants={icon}
        initial="hidden"
        stroke="#00B5AC"
        animate="visible"
        transition={{
            default: { duration: 2, ease: "easeInOut" },
            fill: { duration: 2, ease: [1, 0, 0.8, 1] }
        }}
        />
        <motion.path
        d="M522.136 429.162L556.273 141.026"
        variants={icon}
        initial="hidden"
        stroke="#00B5AC"
        animate="visible"
        transition={{
            default: { duration: 2, ease: "easeInOut" },
            fill: { duration: 2, ease: [1, 0, 0.8, 1] }
        }}
        />
        <motion.path
        d="M523.023 428.569L358.071 32.3252"
        variants={icon}
        initial="hidden"
        stroke="#00B5AC"
        animate="visible"
        transition={{
            default: { duration: 2, ease: "easeInOut" },
            fill: { duration: 2, ease: [1, 0, 0.8, 1] }
        }}
        />
        <motion.path
        d="M358.071 32.5649L555.386 140.193"
        variants={icon}
        initial="hidden"
        stroke="#00B5AC"
        animate="visible"
        transition={{
            default: { duration: 2, ease: "easeInOut" },
            fill: { duration: 2, ease: [1, 0, 0.8, 1] }
        }}
        />
        <motion.path
        d="M358.357 31.732L385.828 322.576"
        variants={icon}
        initial="hidden"
        stroke="#00B5AC"
        animate="visible"
        transition={{
            default: { duration: 2, ease: "easeInOut" },
            fill: { duration: 2, ease: [1, 0, 0.8, 1] }
        }}
        />
        <motion.path
        d="M358.826 31.7319L106.767 239.568"
        variants={icon}
        initial="hidden"
        stroke="#00B5AC"
        animate="visible"
        transition={{
            default: { duration: 2, ease: "easeInOut" },
            fill: { duration: 2, ease: [1, 0, 0.8, 1] }
        }}
        />
        <motion.path
        d="M-49.7754 124.899L555.386 139.269"
        variants={icon}
        initial="hidden"
        stroke="#00B5AC"
        animate="visible"
        transition={{
            default: { duration: 2, ease: "easeInOut" },
            fill: { duration: 2, ease: [1, 0, 0.8, 1] }
        }}
        />
        <motion.path
        d="M167.727 458.221L-49.7754 124.026"
        variants={icon}
        initial="hidden"
        stroke="#00B5AC"
        animate="visible"
        transition={{
            default: { duration: 2, ease: "easeInOut" },
            fill: { duration: 2, ease: [1, 0, 0.8, 1] }
        }}
        />
        <motion.path
        d="M166.159 459.105L359.639 31.7322"
        variants={icon}
        initial="hidden"
        stroke="#00B5AC"
        animate="visible"
        transition={{
            default: { duration: 2, ease: "easeInOut" },
            fill: { duration: 2, ease: [1, 0, 0.8, 1] }
        }}
        />
        <motion.path
        d="M386.114 321.475L107.522 240.67"
        variants={icon}
        initial="hidden"
        stroke="#00B5AC"
        animate="visible"
        transition={{
            default: { duration: 2, ease: "easeInOut" },
            fill: { duration: 2, ease: [1, 0, 0.8, 1] }
        }}
        />
        <motion.path
        d="M107.353 239.568L555.555 141.026"
        variants={icon}
        initial="hidden"
        stroke="#00B5AC"
        animate="visible"
        transition={{
            default: { duration: 2, ease: "easeInOut" },
            fill: { duration: 2, ease: [1, 0, 0.8, 1] }
        }}
        />
        <motion.path
        d="M-44.4176 403.309L386.212 322.577"
        variants={icon}
        initial="hidden"
        stroke="#00B5AC"
        animate="visible"
        transition={{
            default: { duration: 2, ease: "easeInOut" },
            fill: { duration: 2, ease: [1, 0, 0.8, 1] }
        }}
        />
        </g>
            <motion.g
                animate={{ rotate: [10, -10]  }}
                transition={{ duration: .6, yoyo: Infinity }}
            >
                <motion.path
                    animate={{ x: [-5, 0] }}
                    transition={{ yoyo: Infinity }}
                    stroke="#00B5AC"
                    strokeWidth="2"
                    strokeMiterlimit="10"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M493.761 446.543C490.658 444.759 488.535 441.275 488.535 437.196C488.535 433.542 490.331 430.313 493.026 428.358"
                />
                <motion.path
                    animate={{ x: [-5, 0] }}
                    transition={{ yoyo: Infinity }}
                    stroke="#00B5AC"
                    strokeWidth="2"
                    strokeMiterlimit="10"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M498.579 442.889C497.272 441.445 496.456 439.405 496.456 437.196C496.456 435.071 497.191 433.202 498.415 431.757"
                />
                <motion.path
                    animate={{ x: [-5, 0] }}
                    transition={{ yoyo: Infinity }}
                    stroke="#00B5AC"
                    strokeWidth="2"
                    strokeMiterlimit="10"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M498.579 442.889C497.272 441.445 496.456 439.405 496.456 437.196C496.456 435.071 497.191 433.202 498.415 431.757"
                />
                <path d="M523.975 446.713C523.975 448.838 522.26 450.622 520.219 450.622C518.177 450.622 516.462 448.838 516.462 446.713C516.462 444.589 518.177 442.804 520.219 442.804C522.26 442.804 523.975 444.504 523.975 446.713Z" stroke="#00B5AC" stroke-width="2" stroke-miterlimit="10"/>
                <path d="M532.794 435.836C532.059 435.666 531.406 435.071 531.406 434.307V424.959C531.079 419.181 526.833 414.592 521.443 413.912L522.832 394.283C522.832 392.668 521.607 391.393 520.055 391.393C518.504 391.393 517.279 392.668 517.279 394.283L518.667 413.912C513.277 414.592 509.031 419.266 508.705 424.959V434.307C508.705 435.071 508.133 435.751 507.398 436.006C506.173 436.431 504.622 437.536 504.622 440.255V443.909C504.622 445.523 504.785 445.608 506.255 445.608H533.856C535.407 445.608 535.489 445.439 535.489 443.909V440.255C535.489 437.196 534.019 436.176 532.794 435.836Z" fill="white" stroke="#00B5AC" stroke-width="2" stroke-miterlimit="10"/>
                <motion.path
                    animate={{ x: [5, 0] }}
                    transition={{ yoyo: Infinity }}
                    stroke="#00B5AC"
                    strokeWidth="2"
                    strokeMiterlimit="10"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M544.798 446.543C547.901 444.674 550.024 441.19 550.024 437.196C550.024 433.542 548.228 430.313 545.533 428.358"
                />
                <motion.path
                    animate={{ x: [5, 0] }}
                    transition={{ yoyo: Infinity }}
                    stroke="#00B5AC"
                    strokeWidth="2"
                    strokeMiterlimit="10"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M539.98 442.889C541.287 441.445 542.103 439.405 542.103 437.196C542.103 435.071 541.368 433.202 540.143 431.757"
                />
                <path d="M508.623 434.562H531.488" stroke="#00B5AC" stroke-width="2" stroke-miterlimit="10"/>
            </motion.g>
            <motion.g
                animate={{ rotate: [10, -10] }}
                transition={{ duration: 2, yoyo: Infinity, delay: .6 }}
            >
                <path d="M528.386 156.751L528.384 156.747C525.778 150.286 523.555 138.375 522.808 129.233C528.259 128.432 532.392 123.597 532.392 117.81C532.392 117.13 532.337 116.461 532.227 115.804C538.237 114.82 545.546 114.018 549.674 114.018C553.95 114.018 561.611 114.879 567.71 115.924C567.613 116.533 567.561 117.165 567.561 117.81C567.561 123.387 571.413 128.049 576.574 129.139C575.831 138.29 573.576 150.272 570.992 156.751L570.991 156.752C568.829 162.188 563.945 167.375 559.236 171.473C556.897 173.509 554.629 175.251 552.814 176.598C552.142 177.096 551.518 177.55 550.972 177.947C550.476 178.307 550.045 178.621 549.701 178.878C549.375 178.635 548.97 178.341 548.506 178.004C547.939 177.593 547.284 177.118 546.576 176.593C544.757 175.245 542.486 173.499 540.145 171.461C535.432 167.359 530.548 162.172 528.386 156.751Z" fill="white" stroke="#00B5AC" stroke-width="2"/>
                <path d="M537.709 144.815L546.836 154.236L562.809 137.749" stroke="#00B5AC" stroke-width="2" stroke-linecap="round"/>
            </motion.g>
            <motion.g
                animate={{ rotate: [10, -10] }}
                transition={{ yoyo: Infinity, delay: 1 }}
            >
                <path d="M175.622 452.108L175.622 434.972C175.622 430.314 171.975 426.518 167.499 426.518C163.023 426.518 159.376 430.314 159.376 434.972L159.376 452.05L153.077 452.05L153.077 434.972C153.077 426.691 159.542 420.021 167.444 420.021C175.401 420.021 181.811 426.749 181.811 434.972L181.811 452.05L175.622 452.05L175.622 452.108Z" fill="white" stroke="#00B5AC" stroke-width="2" stroke-miterlimit="10"/>
                <path d="M186.011 459.928C186.011 470.566 177.722 479.249 167.444 479.249C157.221 479.249 148.932 470.624 148.932 459.928C148.932 449.29 157.221 440.607 167.499 440.607C177.722 440.607 186.011 449.29 186.011 459.928Z" fill="white" stroke="#00B5AC" stroke-width="2" stroke-miterlimit="10"/>
                <path d="M171.81 456.823C171.81 454.35 169.875 452.28 167.444 452.28C165.068 452.28 163.079 454.293 163.079 456.823C163.079 458.721 164.184 460.331 165.731 461.021L163.963 467.576L170.815 467.576L169.047 461.021C170.76 460.331 171.81 458.721 171.81 456.823Z" fill="#00B5AC"/>
            </motion.g>
            <motion.g
                animate={{ rotate: [-10, 10] }}
                transition={{ yoyo: Infinity, duration: 1 }}
            >
                <path d="M122.164 226.056L108.736 219.322C105.786 217.842 102.318 219.103 100.896 222.173L95.699 233.395C94.3262 236.359 95.4893 240.073 98.4395 241.553L100.271 242.471L97.1327 249.247L96.0136 248.685C95.0981 248.226 94.0427 248.61 93.6015 249.563C93.1602 250.516 93.5291 251.614 94.4447 252.073L95.5637 252.634L94.387 255.175L93.268 254.614C92.3524 254.154 91.297 254.538 90.8558 255.491C90.4145 256.444 90.7834 257.542 91.699 258.001L92.818 258.563L91.6413 261.103L90.5223 260.542C89.6067 260.083 88.5514 260.467 88.1101 261.42C87.6688 262.372 88.0377 263.47 88.9533 263.93L90.0723 264.491L88.1111 268.725C86.8854 271.372 87.8904 274.616 90.4336 275.891L92.9769 277.167C94.4011 277.881 96.2103 277.223 96.8967 275.741L110.037 247.369L111.868 248.288C114.818 249.767 118.286 248.506 119.708 245.436L124.905 234.214C126.327 231.144 125.013 227.485 122.164 226.056ZM114.772 232.003C114.233 233.167 112.876 233.661 111.757 233.099L109.417 231.926C108.298 231.365 107.824 229.953 108.363 228.788L109.442 226.459C109.981 225.295 111.289 224.907 112.408 225.468L114.748 226.642C115.867 227.203 116.341 228.615 115.851 229.674L114.772 232.003Z" fill="white" stroke="#00B5AC" stroke-width="2" stroke-miterlimit="10"/>
                <path d="M106.144 247.113L94.9161 271.356" stroke="#00B5AC" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
            </motion.g>
        </svg>
    )
}

Background.propTypes = {

}

export default Background
